import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getCommentBoxId } from '../../../CommentThread/helpers';
import { getCommentableTypeForDeviationType } from '../../../DeviationPage/redux/helpers';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import CommentOutline from '../../../Icons/CommentOutline';
import { BiEventType, BiDataHook } from '../../../biLogger';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import { MobileContext } from '../../../Context/MobileContext';
import { GlinteractionContext } from '../../_partials/Glinteraction';
import CommentReminderNotification from '../../_partials/CommentReminderNotification';
import { useCustomNotifications } from '../../../Notifications/CustomNotificationContext';
var CommentButton = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, deviationId = _b.deviationId, author = _b.author, typeId = _b.typeId, extended = _b.extended, onScrollToComment = _a.onScrollToComment, onToggleCommentPanel = _a.onToggleCommentPanel, isCommentPanelOpen = _a.isCommentPanelOpen, isOwner = _a.isOwner, actionBarType = _a.actionBarType;
    var t = useTranslation().t;
    var isQuickComment = useFlag('quick_comment');
    var animateJustFaved = useFlag('animated_actions');
    var showCommentReminder = useFlag('fave_comment_tooltip');
    var notifications = useCustomNotifications(['commentReminder']).notifications;
    var _c = useState(false), isNotifDelayOver = _c[0], setIsNotifDelayOver = _c[1];
    var hasJustFavedNotif = notifications.length > 0;
    useEffect(function () {
        if (!hasJustFavedNotif) {
            setIsNotifDelayOver(false);
            return;
        }
        var timeout = setTimeout(function () { return setIsNotifDelayOver(true); }, 1000);
        return function () { return clearTimeout(timeout); };
    }, [hasJustFavedNotif]);
    var isMobile = useContext(MobileContext);
    var shouldGlint = useContext(GlinteractionContext).shouldGlint;
    var onClick = function () {
        if (!extended) {
            return;
        }
        if (isQuickComment && !isMobile) {
            return onToggleCommentPanel(actionBarType);
        }
        var editorId = getCommentBoxId(getCommentableTypeForDeviationType(typeId), deviationId, 'top');
        onScrollToComment(editorId, true);
    };
    return (React.createElement(ActionBarButton, { tooltip: isOwner ? t('actionbar.comment') : undefined, isRelatedPanelOpen: isCommentPanelOpen, onClick: onClick, dataHook: BiDataHook.DEVIATION_FAVES_COUNTER, biData: {
            evid: BiEventType.THUMB_CLICK_COMMENT,
            typeid: getDeviationResourceType(deviation),
            creatorid: author && author.useridUuid,
            itemid: deviationId,
        }, label: isOwner ? undefined : t('actionbar.comment'), notificationTypes: isNotifDelayOver && showCommentReminder ? ['commentReminder'] : [], customNotificationRender: showCommentReminder
            ? function (notification) {
                switch (notification.type) {
                    case 'commentReminder':
                        return (React.createElement(CommentReminderNotification, { deviation: deviation, id: notification.id, queueName: notification.queueName }));
                    default:
                        return null;
                }
            }
            : undefined },
        React.createElement(ActionBarIcon, { icon: CommentOutline, isGlinting: (animateJustFaved && showCommentReminder && hasJustFavedNotif) ||
                (shouldGlint === 'comment' && !isCommentPanelOpen) })));
};
CommentButton.displayName = 'CommentButton';
export default CommentButton;
//# sourceMappingURL=CommentButton.js.map